import { createRouter, createWebHistory } from 'vue-router';
import { defineAsyncComponent as dac } from 'vue';

import ROUTES from 'routes';
import { PROD } from 'const';
import { PERMS } from 'const/access';
import Page404 from 'pages/Page404.vue';
import Page420 from 'pages/Page420.vue';
import PageAccess from 'components/PageAccess';

import OAuthReturn from 'pages/Login/AdsAccOAuthReturn';

// import Apps from 'pages/Apps/Apps.vue';
import Advers from 'pages/Apps/Advers.vue';

// import Test from 'pages/Test';

// const Apps = () => import(/* webpackChunkName: "Apps" */ 'pages/Apps/Apps.vue');

const Manage = dac(() => import(/* webpackChunkName: "Manage" */ 'pages/Manage/Manage.vue'));
const ManageUser = dac(() => import(/* webpackChunkName: "Manage" */ 'pages/Manage/ManageUser.vue'));
const Insights = () => import(/* webpackChunkName: "Insights" */ 'pages/Insights/Insights.vue');
const AInvites = dac(() => import(/* webpackChunkName: "Other" */ 'pages/Admin/AInvites'));
const AFeedback = () => import(/* webpackChunkName: "Other" */ 'pages/Admin/AFeedback');


const Predictions = () => import(/* webpackChunkName: "Predictions" */ 'pages/Predictions/Predictions');
const Prediction = () => import(/* webpackChunkName: "Predictions" */ 'pages/Predictions/Prediction');

const Billing = dac(() => import(/* webpackChunkName: "Billing" */ 'pages/Billing/Billing'));
const BInvoicePrint = () => import(/* webpackChunkName: "Billing" */ 'pages/Billing/BInvoicePrint');

const AdsAccs = () => import(/*webpackChunkName: "AdsAccs"*/ 'pages/AdsAccs/AdsAccs.vue');

const Conversions = () => import(/*webpackChunkName: "Conversions"*/ 'pages/Conversions/Conversions.vue');
const Conversion = () => import(/*webpackChunkName: "Conversions"*/ 'pages/Conversions/Conversion.vue');

const DataSources = () => import(/*webpackChunkName: "DataSources"*/ 'pages/DataSources/DataSources.vue');

// eslint-disable-next-line
// const CampaignsDrafts = () => import(/*webpackChunkName: "Camps"*/ 'pages/Campaigns/CampaignsDrafts.vue');
const Apps = () => import(/*webpackChunkName: "Apps"*/ 'pages/Apps/Apps.vue');
const AppSettings = () => import(/*webpackChunkName: "Apps"*/ 'pages/AppSettings/AppSettings.vue');
const Campaigns = () => import(/*webpackChunkName: "Camps"*/ 'pages/Campaigns/Campaigns.vue');
const Campaign = () => import(/*webpackChunkName: "Camps"*/ 'pages/Campaigns/Campaign.vue');
const CampCreate = () => import(/*webpackChunkName: "Camps"*/ 'pages/Campaigns/CampCreate.vue');
const Creatives = () => import(/*webpackChunkName: "Creatives"*/ 'pages/Creatives/Creatives.vue');

// eslint-disable-next-line
const Audiences2 = () => import(/*webpackChunkName: "Auds"*/ 'pages/Auds/Auds2.vue');
const Auditory2 = () => import(/*webpackChunkName: "Auds"*/ 'pages/Auds/Aud.vue');
const AdsAccsEdit = () => import(/*webpackChunkName: "AdsAccs"*/ 'pages/AdsAccs/AdsAccEdit.vue');
const AdsAccsCreate = () => import(/*webpackChunkName: "AdsAccs"*/ 'pages/AdsAccs/AdsAccCreate.vue');

// import UiKit from 'pages/UiKit.vue';
// const UiKit = () => import(/* webpackChunkName: "UiKit" */ 'pages/UiKit.vue');
// import Login from 'pages/Login.vue';

const GUEST = { meta: { guest: true } };

function VueRoute (path, component, opts) {
  return {
    path,
    name: path,
    component,
    ...opts,
  };
}

const routes = [
  // VueRoute(ROUTES.ROOT, { redirect: { name: ROUTES.ADVER.LIST } }),

  // Advers
  VueRoute(ROUTES.ROOT, Advers),
  VueRoute(ROUTES.ADVER.LIST, Advers),
  VueRoute(ROUTES.ADVER.ROOT, null, { redirect: { name: ROUTES.ADVER.CAMPAIGNS } }),

  VueRoute(ROUTES.ADVER.APPS, Apps),
  VueRoute(ROUTES.ADVER.APP_SETTINGS, AppSettings),
  VueRoute(ROUTES.ADVER.CAMPAIGNS, Campaigns),
  VueRoute(ROUTES.ADVER.CAMPAIGNS_CREATE, CampCreate),
  VueRoute(ROUTES.ADVER.CAMPAIGN, Campaign),

  VueRoute(ROUTES.ADVER.AUDIENCES, Audiences2),
  VueRoute(ROUTES.ADVER.AUDIENCE_VIEW, Auditory2),

  VueRoute(ROUTES.ADVER.CREATIVES, Creatives),

  VueRoute(ROUTES.ADVER.DATA_SOURCES, DataSources),
  VueRoute(ROUTES.ADVER.DATA_SOURCE_EDIT, DataSources),

  VueRoute(ROUTES.ADVER.ADS_ACCOUNTS, AdsAccs),
  VueRoute(ROUTES.ADVER.ADS_ACCOUNTS_EDIT, AdsAccsEdit),
  VueRoute(ROUTES.ADVER.ADS_ACCOUNTS_CREATE, AdsAccsCreate),

  // Other
  VueRoute(ROUTES.MANAGE, PageAccess(Manage, PERMS.MANAGE.VIEW)),
  VueRoute(ROUTES.MANAGE_USER, PageAccess(ManageUser, PERMS.MANAGE.VIEW)),

  VueRoute(ROUTES.CHANGE_PSWD, GUEST),
  VueRoute(ROUTES.ACTIVATE, GUEST),
  VueRoute(ROUTES.ACTIVATE_INVITED, GUEST),

  // VueRoute('/ui-kit-kit', UiKit),

  // App
  VueRoute(ROUTES.APP_OLD_ANY, {
    render () { return null },
    beforeMount () {
      const path = this.$route.path.replace('/application', '/app');
      this.$router.replace(path);
    },
  }),

  VueRoute(ROUTES.APP, null, { redirect: { name: ROUTES.AUDIENCES } }),

  VueRoute(ROUTES.DATA_SOURCES, DataSources),
  VueRoute(ROUTES.DATA_SOURCE_EDIT, DataSources),
  // VueRoute(ROUTES.DATA_SOURCES_CREATE, DataSources),

  VueRoute(ROUTES.PREDICTIONS, Predictions),
  VueRoute(ROUTES.PREDICTION, Prediction),

  VueRoute(ROUTES.CREATIVES, Creatives),

  VueRoute(ROUTES.CAMPAIGNS, Campaigns),
  VueRoute(ROUTES.CAMPAIGNS_CREATE, CampCreate),
  VueRoute(ROUTES.CAMPAIGN, Campaign),

  VueRoute(ROUTES.AUDIENCES, Audiences2),
  VueRoute(ROUTES.AUDIENCE_VIEW, Auditory2),

  VueRoute(ROUTES.ADS_ACCOUNTS, AdsAccs),
  VueRoute(ROUTES.ADS_ACCOUNTS_EDIT, AdsAccsEdit),

  VueRoute(ROUTES.CONVERSIONS, Conversions),
  VueRoute(ROUTES.CONVERSION, Conversion),
  VueRoute(ROUTES.CONVERSION_SEGMENT, Conversion),

  VueRoute(ROUTES.INSIGHTS, Insights, { meta: { preventScroll: true } }),

  VueRoute(ROUTES.IDENTITY_PROFILE, Page420),

  VueRoute(ROUTES.ADMIN, Page420),
  VueRoute(ROUTES.ADMIN_INVITES, PageAccess(AInvites, PERMS.ADMIN.VIEW)),

  VueRoute(ROUTES.ADMIN_FEEDBACK, AFeedback),

  VueRoute(ROUTES.GOOGLE_OAUTH_CALLBACK, OAuthReturn),
];

function enableIfNotProd (vueRoute) {
  if (PROD) {
    const { name, path } = vueRoute;
    return routes.push({ component: Page420, name, path });
  }
  routes.push(vueRoute);
}

enableIfNotProd(VueRoute(ROUTES.BILLING, PageAccess(Billing, PERMS.BILLING.VIEW)));
enableIfNotProd(VueRoute(ROUTES.BILLING_INVOICE, BInvoicePrint));

// enableIfNotProd(VueRoute('/test', Test));


routes.push(
  VueRoute('/:pathMatch(.*)*', Page404),
);

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  scrollBehavior (to, from, savedPosition) {
    return /*!window.__TESTING && */!to.meta.preventScroll && (savedPosition || { left: 0, top: 0 });
  },
  routes,
});

export default router;
